import { Form, message } from "antd";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CustomIcon from "../../../commons/components/CustomIcon/CustomIcon";
import CustomInput from "../../../commons/components/CustomInput/CustomInput";
import GradientText from "../../../commons/components/GradientText/GradientText";
import PrimaryButton from "../../../commons/components/PrimaryButton/PrimaryButton";
import { MERCHANT, REFRESH_TOKEN_KEY, TOKEN_KEY } from "../../../commons/constants";
import { LOGIN_URL } from "../../../commons/constants/api-urls";
import { routerNavigation, routers } from "../../../commons/constants/routers";
import { MODES } from "../../../commons/constants/user";
import { LockOutlineIcon, TrifoodLogo, UserOctagonIcon } from "../../../commons/resources";
import defaultAxios from "../../../commons/utils/axios";
import { AppContext } from "../../../contexts/AppContext";
import styles from "./login-form.module.scss";

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const { setUser, setCurrentStore } = useContext(AppContext);
  const [form] = Form.useForm<LoginBody>();
  const onFinish = async (values: LoginBody) => {
    try {
      const res = await defaultAxios.put<LoginResponse>(LOGIN_URL, values);
      localStorage.setItem(TOKEN_KEY, res.data.access_token);
      localStorage.setItem(REFRESH_TOKEN_KEY, res.data.refresh_token);
      localStorage.setItem(MERCHANT, JSON.stringify(res.data));
      setUser(res.data);

      switch (res.data.merchant_role.id) {
        case MODES.ADMIN:
          navigate(routerNavigation.DASHBOARD);
          return;
        case MODES.USER:
          setCurrentStore(res.data.merchantStoreAuthorities[0].merchantStore);
          navigate(routerNavigation.STORES.REPORT(res.data.merchantStoreAuthorities[0].merchantStore.id));
          return;
        default:
          navigate(routers.WELCOME);
          return;
      }
    } catch (error: any) {
      console.log(error);
      message.error("Login Failed");
    }
  };

  return (
    <div className={styles.formWrapper}>
      <Form
        form={form}
        name="basic"
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true, username: "", password: "" }}
        onFinish={onFinish}
        autoComplete="off"
        className={styles.form}
      >
        <div className={styles.logoWrapper}>
          <TrifoodLogo />
        </div>

        <div className={styles.platform}>MERCHANT PLATFORM</div>
        <div className={styles.title}>Login</div>
        <div className={styles.inputWrapper}>
          <CustomInput
            placeholder="Email"
            name="identifier"
            rules={[
              {
                required: true,
                message: "This field is required",
                whitespace: true,
              },
            ]}
            prefix={<CustomIcon icon={UserOctagonIcon} fill="currentColor" width={20} />}
          />
          <CustomInput
            placeholder="Password"
            type="password"
            name="password"
            rules={[
              {
                required: true,
                message: "This field is required",
                whitespace: true,
              },
            ]}
            prefix={<CustomIcon icon={LockOutlineIcon} fill="currentColor" width={20} />}
          />
        </div>
        <div className={styles.forgotPassword} onClick={() => navigate(routers.FORGOT_PASSWORD)}>
          Forgot password?
        </div>
        <PrimaryButton type="submit" className={styles.loginBtn}>
          Login
        </PrimaryButton>
        <div className={styles.signUp}>
          Boost Your Business, Reach More Eaters <br />
          <GradientText
            onClick={() => navigate(routers.SIGN_UP)}
            className={styles.signUplink}
            text={"Sign Up with TriFood Today!"}
          />
        </div>
      </Form>
    </div>
  );
};

export default LoginForm;
